"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.statusText = exports.statusBg = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

// Indicator
var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("line-height:", theme.lineHeight.leadingNormal, ";border-radius:6px;display:inline-block;font-weight:", theme.fontWeight.medium, ";font-size:", theme.fontSize.xsmall, ";letter-spacing:0;padding:", (0, _util.rem)(2), " ", theme.spacing['5'], ";color:", theme.color.monochrome.white, ";&::first-letter{text-transform:uppercase;}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var defaultPositive = function defaultPositive(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.secondary.positive, ";color:", theme.color.primary.positive, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultPositive;"));
};

var accentPositive = function accentPositive(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.primary.positive, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:accentPositive;"));
};

var defaultNeutral = function defaultNeutral(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.monochrome.light, ";color:", theme.color.monochrome.mediumDark, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultNeutral;"));
};

var accentNeutral = function accentNeutral(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.monochrome.light, ";color:", theme.color.monochrome.mediumDark, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:accentNeutral;"));
};

var defaultNegativeAlt = function defaultNegativeAlt(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.secondary.negativeAlt, ";color:", theme.color.primary.negativeAlt, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultNegativeAlt;"));
};

var accentNegativeAlt = function accentNegativeAlt(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.primary.negativeAlt, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:accentNegativeAlt;"));
};

var defaultNegative = function defaultNegative(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.secondary.negative, ";color:", theme.color.primary.negative, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultNegative;"));
};

var accentNegative = function accentNegative(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.primary.negative, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:accentNegative;"));
};

var defaultWarning = function defaultWarning(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.secondary.warning, ";color:", theme.color.primary.warningText, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultWarning;"));
};

var accentWarning = function accentWarning(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";background-color:", theme.color.primary.warning, ";color:", theme.color.monochrome.black, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:accentWarning;"));
}; // Status


var dot = /*#__PURE__*/(0, _react.css)("height:", (0, _util.rem)(8), ";width:", (0, _util.rem)(8), ";border-radius:50%;display:inline-block;" + (process.env.NODE_ENV === "production" ? "" : ";label:dot;"));

var onlineBg = function onlineBg(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.status.online, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:onlineBg;"));
};

var awayBg = function awayBg(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.status.away, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:awayBg;"));
};

var offlineBg = function offlineBg(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.status.offline, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:offlineBg;"));
};

var outBg = function outBg(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.status.out, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:outBg;"));
};

var online = function online(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.status.online, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:online;"));
};

var away = function away(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.status.away, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:away;"));
};

var offline = function offline(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.status.offline, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:offline;"));
};

var out = function out(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.status.out, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:out;"));
};

var statusBg = {
  online: onlineBg,
  away: awayBg,
  offline: offlineBg,
  out: outBg
};
exports.statusBg = statusBg;
var statusText = {
  online: online,
  away: away,
  offline: offline,
  out: out
};
exports.statusText = statusText;
var styles = {
  defaultPositive: defaultPositive,
  accentPositive: accentPositive,
  defaultNeutral: defaultNeutral,
  accentNeutral: accentNeutral,
  defaultNegativeAlt: defaultNegativeAlt,
  accentNegativeAlt: accentNegativeAlt,
  defaultNegative: defaultNegative,
  accentNegative: accentNegative,
  defaultWarning: defaultWarning,
  accentWarning: accentWarning,
  dot: dot
};
exports.styles = styles;
//# sourceMappingURL=indicator.styles.js.map